export function getImage(uuid, { baseURL, modifiers } = {}) {
  const searchParams = new URLSearchParams(modifiers)
  const stringParams = searchParams.toString() ? `?${searchParams}` : ''

  return { url: `${baseURL}${uuid}${stringParams}` }
}
